module.exports = __webpack_public_path__ + "img/search-by-zip-navy.8587f3bc.png";